import { Injectable, NgZone } from '@angular/core';

import { LayoutService } from '@/layout/service/layout.service';
import { Router } from '@angular/router';
import { UserAccountDialogComponent } from 'app/admin/user-account-dialog.component';
import { AppNavigationService } from 'app/layout/service/app.navigation.service';
import { MenuItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { AuthService } from './auth.service';
import { DialogBaseComponent } from './dialog-base.component';
import { UtilFns } from './util-fns';

@Injectable({ providedIn: 'root' })
export class PrimeNGUtilService {
  constructor(
    private _navigationService: AppNavigationService,
    private layoutService: LayoutService,
    private _authService: AuthService,
    private _router: Router,
    public pngDialogService: DialogService,
    private _ngZone: NgZone,
  ) {}

  async setupNavigation() {
    const isLoggedIn = await this._authService.isLoggedIn();
    if (!isLoggedIn) return;

    this._navigationService.show();
    await this.updateDefaultNavigation();
    this.addOptionsNavigation();
  }

  private async updateDefaultNavigation() {
    const user = this._authService.getUser();

    if (user.isUserAdmin) {
      this._navigationService.setVisible('user', false);
    } else {
      this._navigationService.setVisible('user', true);
      const userItem: MenuItem = this._navigationService.getNavigationItem('user');
      if (!userItem) return;
      userItem.command = () => {
        const user = this._authService.getUser();
        return DialogBaseComponent.open(UserAccountDialogComponent, this, {
          userName: user.loginName,
        });
      };
    }
  }

  private addOptionsNavigation() {
    const key = 'options';
    let item = this._navigationService.getNavigationItem(key);
    if (item) {
      this._navigationService.removeNavigationItem(key);
    }
    // if (item != null) { return; }
    const customFunctionNavItem: MenuItem = {
      id: key,
      label: 'Options',
      icon: 'fa fa-sharp-duotone fa-solid fa-cogs',
      items: [
        {
          id: 'printersetup',
          label: 'Printers & Diagnostics',
          command: () => {
            this.layoutService.showRightMenu();
          },
          icon: 'fa-solid fa-print',
        },
        {
          id: 'logout',
          label: 'Logout',
          command: () => {
            this._authService.logout();
          },
        },
      ],
    };

    const user = this._authService.getUser();

    if (user.isAccountingAdmin) {
      customFunctionNavItem.items.splice(
        1,
        0,
        {
          id: 'quickbooks',
          label: 'QuickBooks Online',
          url: 'https://app.sandbox.qbo.intuit.com/app/homepage',
          target: '_blank',
          icon: 'fa-solid fa-external-link',
        },
        {
          id: 'shipStationApiDashboard',
          label: 'ShipStation API Dashboard',
          url: 'https://dashboard.shipengine.com/',
          target: '_blank',
          icon: 'fa-solid fa-tachometer-alt',
        },
      );
    }

    this._navigationService.addNavigationItem(customFunctionNavItem, 'end');
  }

  /** Expose window.navigateByUrl function to be called by Puppeteer */
  private setupWindowRouting() {
    const win = window as any;
    win.navigateByUrl = this.navigateByUrl.bind(this);
  }

  navigateByUrl(url: string) {
    url = UtilFns.trimBasePrefixFromPath(url);
    return this._ngZone.run(() => this._router.navigateByUrl(url));
  }
}
